<template>

    <section
        id="ministries"
        class="ministries"
    >

        <div class="ministries__container">

            <h2 class="ministries__title">
                {{ 'home_ministries' | staticTitle }}
            </h2>

            <div class="ministries__slider">

                <article
                    v-for="(ministry, index) in $options.filters.portfolioFetchBy('ministries')"
                    :key="ministry.id || index"
                    class="ministry-card"
                >

                    <div class="ministry-card__image">

                        <img
                            v-if="ministry.imagenes_id"
                            :src="ministry.imagenes_id | imageIdToURL"
                            :alt="ministry.title"
                        >

                        <span class="ministry-card__icon">
                            +
                        </span>

                    </div>

                    <h3>
                        {{ ministry.title }}
                    </h3>

                    <div
                        v-if="ministry.content_alt"
                        class="ministry-card__content"
                    >

                        <vue-marked>
                            {{ ministry.content_alt }}
                        </vue-marked>

                    </div>

                    <router-link
                        :to="{
                            name: 'MinistryDetail',
                            params: {
                                id: ministry.id,
                                title: ministry.title
                            }
                        }"
                        class="ministry-card__link"
                    >

                        {{ 'home_ministries_learn_more' | staticTitle }}

                        <span>
                            →
                        </span>

                    </router-link>

                </article>

            </div>

            <div class="ministries__dots">

                <span class="active"></span>
                <span></span>
                <span></span>

            </div>

        </div>

    </section>

</template>

<script>
export default {
    name: 'HomeMinistries'
};
</script>

<style lang="scss" scoped>
.ministries {
    background:
        var(--background);

    padding:
        50px 20px;

    &__container {
        max-width:
            1200px;

        margin:
            0 auto;
    }

    &__title {
        margin-bottom:
            35px;

        text-align:
            center;

        font-family:
            'Cormorant Garamond',
            serif;

        font-size:
            28px;

        font-weight:
            600;

        color:
            var(--text);
    }

    &__slider {
        display:
            flex;

        gap:
            20px;

        overflow-x:
            auto;

        scroll-snap-type:
            x mandatory;

        padding-bottom:
            15px;

        scrollbar-width:
            none;

        -webkit-overflow-scrolling:
            touch;

        &::-webkit-scrollbar {
            display:
                none;
        }
    }

    &__dots {
        display:
            flex;

        justify-content:
            center;

        gap:
            8px;

        margin:
            20px 0;

        span {
            width:
                10px;

            height:
                10px;

            border-radius:
                50%;

            background:
                var(--gray-200);
        }

        .active {
            background:
                var(--primary);
        }
    }
}

.ministry-card {
    flex:
        0 0 220px;

    display:
        flex;

    flex-direction:
        column;

    padding-bottom:
        25px;

    background:
        var(--background);

    border:
        1px solid
        #eeeeee;

    border-radius:
        5px;

    text-align:
        center;

    scroll-snap-align:
        start;

    box-shadow:
        0 5px 15px
        rgba(0, 0, 0, .05);

    transition:
        transform .35s ease,
        box-shadow .35s ease;

    &__image {
        position:
            relative;

        overflow:
            hidden;

        min-height:
            175px;

        background:
            #f1f1f1;

        img {
            display:
                block;

            width:
                100%;

            height:
                175px;

            object-fit:
                cover;

            object-position:
                center;

            border-radius:
                5px 5px 0 0;

            transition:
                transform .4s ease;
        }
    }

    &__icon {
        position:
            absolute;

        bottom:
            -18px;

        left:
            50%;

        transform:
            translateX(-50%);

        width:
            40px;

        height:
            40px;

        border-radius:
            50%;

        background:
            var(--primary);

        color:
            var(--white);

        display:
            flex;

        align-items:
            center;

        justify-content:
            center;

        font-size:
            30px;

        font-weight:
            300;

        line-height:
            1;
    }

    h3 {
        min-height:
            45px;

        margin:
            35px 0 12px;

        display:
            flex;

        align-items:
            center;

        justify-content:
            center;

        padding:
            0 12px;

        font-family:
            'Poppins',
            sans-serif;

        font-size:
            15px;

        font-weight:
            700;

        color:
            var(--text);

        line-height:
            1.5;

        text-transform:
            uppercase;
    }

    &__content {
        min-height:
            80px;

        flex-grow:
            1;

        padding:
            0 25px;

        font-family:
            'Poppins',
            sans-serif;

        font-size:
            13px;

        color:
            var(--text-light);

        line-height:
            1.7;

        ::v-deep p {
            margin:
                0;
        }

        ::v-deep p + p {
            margin-top:
                10px;
        }
    }

    &__link {
        display:
            inline-flex;

        gap:
            10px;

        align-items:
            center;

        justify-content:
            center;

        margin-top:
            auto;

        padding:
            20px 20px 0;

        color:
            var(--primary);

        font-size:
            13px;

        font-weight:
            600;

        text-decoration:
            none;

        transition:
            color .3s ease,
            gap .3s ease;

        span {
            transition:
                transform .3s ease;
        }

        &:hover {
            color:
                var(--primary-hover);

            gap:
                14px;

            span {
                transform:
                    translateX(3px);
            }
        }
    }
}

@media (hover: hover) {
    .ministry-card:hover {
        transform:
            translateY(-8px)
            scale(1.03);

        box-shadow:
            0 15px 35px
            rgba(0, 0, 0, .12);

        .ministry-card__image img {
            transform:
                scale(1.03);
        }
    }
}

@media (min-width: 1200px) {
    .ministries {

        &__slider {
            overflow:
                visible;

            display:
                grid;

            grid-template-columns:
                repeat(6, 1fr);

            gap:
                25px;
        }

        &__dots {
            display:
                none;
        }
    }

    .ministry-card {
        flex:
            none;
    }
}
</style>